module.exports = __webpack_public_path__ + "static/WindingWorlds1-4b68b358c2339a1e90189de5a5658c69.png";